import { API } from '@aws-amplify/api';
import { Amplify } from 'aws-amplify';
import { GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import { Auth } from 'aws-amplify';

async function retryReq(fn, args, callback, retries = 1) {
  try {
    return await fn(...args);
  } catch (error) {
    const errorResponseStatus = error?.response?.status || error?.status;

    if (
      retries > 0 &&
      (errorResponseStatus === 401 || errorResponseStatus === 403)
    ) {
      const session = await Auth.currentSession();
      const idToken = session.getIdToken().getJwtToken();

      callback(session);
      args[2].headers.Authorization = idToken;
      await retryReq(fn, args, callback, retries - 1);
    } else {
      if (errorResponseStatus === 401 || errorResponseStatus === 403) {
        window.location.href = `/login?path=${window.location.pathname}`; // Redireciona para a página de login
      }
      throw error;
    }
  }
}

export const initAmplify = awsExports => {
  Amplify.configure({
    aws_appsync_graphqlEndpoint: awsExports.GRAPHQL_URL,
    aws_appsync_region: 'us-west-2',
    aws_appsync_authenticationType: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
    Auth: {
      region: awsExports.REGION,
      userPoolId: awsExports.USER_POOL_ID,
      userPoolWebClientId: awsExports.USER_POOL_APP_CLIENT_ID,
    },
    API: {
      endpoints: [
        {
          name: 'admin',
          endpoint: awsExports.ENDPOINT_ADMIN,
          region: awsExports.REGION,
        },
      ],
    },
  });
};

// deprecated: use adminAPI or other service instead getApiInterceptor
export const getApiInterceptor = () => ({
  get: (callback, ...args) => retryReq(API.get.bind(API), args, callback),
  post: (callback, ...args) => retryReq(API.post.bind(API), args, callback),
  put: (callback, ...args) => retryReq(API.put.bind(API), args, callback),
  del: (callback, ...args) => retryReq(API.del.bind(API), args, callback),
  patch: (callback, ...args) => retryReq(API.patch.bind(API), args, callback),
  // Adicione wrappers semelhantes para outros métodos, se necessário.
});
